const module = { name: 'focusableInput/form', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



import { focusableInput_error as focusableError } from 'require-global';



const Selectors = {
    INPUT: '.js-fcsbl-input',
}
function onValueChange() {
    const $input = $(this);
    focusableError.toggle($input, '', false);
}
function attach(form) {
    form.querySelectorAll(Selectors.INPUT)
        .forEach((field) => {
        field.addEventListener('input', onValueChange);
    });
}
module.exports = {
    attach,
    toggleErrors(fields, show) {
        focusableError.toggleErrors(fields, show);
    }
};
export default module.exports;